import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {  map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FeedbackContact } from '../_models/feedback-contact';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const httpOptionsFile = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class FeedBackContactService {
  filesList:Array<File>

  constructor(private http: HttpClient) { }

  /*----FeedBackContactService Controller URL'----*/
  public static readonly URL_SAVE_FEEDBACK_CONTACT_CONTROLLER = environment.apiURL + 'saveFeedBackContact/';

  /* ----Method to save feedback, contact us, bug, comment, question---*/
   
  saveFeedBackAndContact(feedBackContactDataForm: FeedbackContact, feedbackfile :Array<File>){
    console.log(feedbackfile)
    const formData: any = new FormData();
    console.log( "add feedback length" + feedbackfile.length);

    for(let i = 0; i < feedbackfile.length; i++){
       formData.append('feedbackfile', feedbackfile[i]);
       //this.filesList = feedbackfile;
    }
    formData.append("feedBackContactDataForm", JSON.stringify(feedBackContactDataForm));
    return this.http.post<FeedbackContact>(FeedBackContactService.URL_SAVE_FEEDBACK_CONTACT_CONTROLLER,formData,httpOptionsFile);
  }

}

